


































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencyModule } from '@/store/modules/agency';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { AppModule } from '@/store/modules/app';
import WorkerDetails from '@/components/Workers/WorkerDetails.vue';
import WorkerUserDetails from '@/components/Workers/WorkerUserDetails.vue';
import WorkerPermDetails from '@/components/Workers/WorkerPermDetails.vue';
import WorkerTempDetails from '@/components/Workers/WorkerTempDetails.vue';
import WorkerAvailability from '@/components/Workers/WorkerTempDetails.vue';
import WorkerPositions from '@/components/WorkerPositions/WorkerPositions.vue';
import WorkerPayslips from '@/components/Workers/WorkerPayslips.vue';
import WorkerPayroll from '@/components/Workers/WorkerPayroll.vue';
import WorkerShifts from '@/components/Timesheets/WorkerShifts.vue';
import WorkerAgencyWorkerRights from '@/components/AgencyWorkerRights/WorkerAgencyWorkerRights.vue';
import WorkerSkills from '@/components/WorkerSkills/WorkerSkills.vue';
import WorkerQualifications from '@/components/WorkerQualifications/WorkerQualifications.vue';
import NavigationScope from '@/models/Shared/NavigationScope';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import EntityType from '@/models/Shared/EntityType';
import Notes from '@/components/Notes/Notes.vue';
import Documents from '@/components/Documents/Documents.vue';
import WorkType from '@/models/Shared/WorkType';
import GiganautVue from '@/components/Shared/GiganautVue'
import WorkerStatusEdit from '@/components/Workers/WorkerStatusEdit.vue';
import WorkerStatus from '@/components/Workers/Display/WorkerStatus.vue';
import WorkerStatusEnum from '@/models/Workers/WorkerStatus';
import WorkerContactsList from '@/components/ContactWorkers/WorkerContactsList.vue'
import JobWorkersList from '@/components/JobWorkers/JobWorkersList.vue'
import WorkerLocationList from '@/components/Workers/WorkerLocationsList.vue';
import WorkerConversations from '@/components/Conversations/WorkerConversations.vue';
import ActivityTimeline from '@/components/Activities/ActivityTimeline.vue';
import TaskGrid from '@/components/Activities/TaskGrid.vue';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';

@Component({
  name: 'Worker',
  components: { WorkerPayslips, WorkerPayroll, WorkerDetails, WorkerConversations, WorkerUserDetails, WorkerPermDetails, JobWorkersList, WorkerLocationList, WorkerTempDetails, WorkerAvailability, WorkerShifts, WorkerAgencyWorkerRights, WorkerContactsList, WorkerPositions, WorkerSkills, WorkerQualifications, WorkerStatus, WorkerStatusEdit, Notes, Documents, Alert, ActivityTimeline, TaskGrid }
})
export default class extends GiganautVue {

  entityType = EntityType.Worker;
  activityEntityType = ActivityEntityType.Worker;
  workerStatusEnum = WorkerStatusEnum;

  async created() {
    
  }

  get isTemp() {
    return WorkerDetailsModule.currentWorker.workTypes.includes(WorkType.Temp);
  }

  get isPerm() {
    return WorkerDetailsModule.currentWorker.workTypes.includes(WorkType.Perm);
  }
 

  get currentWorker() {
    return WorkerDetailsModule.currentWorker;
  }

  get avatarThumbnailUrl() {
      return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + this.currentWorker.id + "/resized-100/" + this.currentWorker.avatar;
  }

  get loading() {
    return WorkerDetailsModule.loading;
  }

  async navigateToWorkerList() {
    this.$router.push({ name: PageNames.AgencyWorkers});
    
  }
}
